module.exports = [{"name":"","items":[{"name":"home","path":"/","icon":"home"},{"name":"documentation","external":"https://doc.letgogamingapi.com/","icon":"book"}]},{"name":"data_management","items":[{"name":"categories","path":"/categories","icon":"list"},{"name":"companies","path":"/companies","icon":"building"},{"name":"games","path":"/games","icon":"gamepad"},{"name":"sites","path":"/sites","icon":"network-wired"},{"name":"users","path":"/users","icon":"user"}]},{"name":"reports","items":[{"name":"stats","path":"/stats","icon":"chart-bar"},{"name":"total","path":"/total","icon":"list-alt"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/data/menu.json
// module id = sepk
// module chunks = 1